/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DocumentSummary = {
  documentId: string;
  summary: string;
};

/** @internal */
export const DocumentSummary$inboundSchema: z.ZodType<
  DocumentSummary,
  z.ZodTypeDef,
  unknown
> = z.object({
  document_id: z.string(),
  summary: z.string(),
}).transform((v) => {
  return remap$(v, {
    "document_id": "documentId",
  });
});
/** @internal */
export type DocumentSummary$Outbound = {
  document_id: string;
  summary: string;
};

/** @internal */
export const DocumentSummary$outboundSchema: z.ZodType<
  DocumentSummary$Outbound,
  z.ZodTypeDef,
  DocumentSummary
> = z.object({
  documentId: z.string(),
  summary: z.string(),
}).transform((v) => {
  return remap$(v, {
    documentId: "document_id",
  });
});

export function documentSummaryToJSON(
  documentSummary: DocumentSummary,
): string {
  return JSON.stringify(DocumentSummary$outboundSchema.parse(documentSummary));
}
export function documentSummaryFromJSON(
  jsonString: string,
): SafeParseResult<DocumentSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DocumentSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DocumentSummary' from JSON`,
  );
}
